module.exports = __webpack_public_path__ + "img/manufacturer-icon.1d001541.svg";